export const getFormattedName = (name, isDisplayLastNameFirst) => {
  let formattedName = '';

  if (isDisplayLastNameFirst) {
    if (name.lastName && name.lastName !== '') {
      formattedName = name.lastName;
    }
    if (name.firstName && name.firstName !== '') {
      formattedName = formattedName +
        (formattedName !== '' ? ', ' : '') +
        name.firstName;
    }
    if (name.middleInitial && name.middleInitial !== '') {
      formattedName = formattedName + ' ' + name.middleInitial;
    }
    if (name.suffix && name.suffix !== '') {
      formattedName = formattedName + ' ' + name.suffix;
    }
  } else {
    if (name.firstName && name.firstName !== '') {
      formattedName = name.firstName;
    }
    if (name.middleInitial && name.middleInitial !== '') {
      formattedName = formattedName + ' ' + name.middleInitial;
    }
    if (name.lastName && name.lastName !== '') {
      formattedName = formattedName + ' ' + name.lastName;
    }
    if (name.suffix && name.suffix !== '') {
      formattedName = formattedName + ' ' + name.suffix;
    }
  }

  if (name.title && name.title !== '') {
    formattedName = formattedName + ' - ' + name.title;
  }

  return formattedName;
};
